import React from "react";
import "./Resume.css";
import useInView from "../hooks/useInView";

function Resume() {
	const [ref, visible] = useInView();

	return (
		<div className="resume" id="resume">
			<div className="shimmer resume_background">resume</div>
			<div
				ref={ref}
				className={`${visible ? "resume_reveal" : "resume_reveal_inactive"}`}
			>
				<div className="resume_container">
					<div className="resume_download_row">
						<a
							className="resume_download_btn"
							href="/Wyatt_Chamberlin_Resume.pdf"
							download
							target="_blank"
							rel="noopener noreferrer"
						>
							↓ Download PDF
						</a>
					</div>

					<section className="resume_section">
						<h2 className="resume_section_title">Summary</h2>
						<p className="resume_summary">
							Shopify Frontend Developer building high-performing eCommerce
							experiences using Liquid, JavaScript, and React. Focused on theme
							development, Storefront API integrations, and conversion-optimized
							shopping experiences.
						</p>
					</section>

					<section className="resume_section">
						<h2 className="resume_section_title">Skills</h2>
						<div className="resume_skills_grid">
							<span className="resume_skill">JavaScript</span>
							<span className="resume_skill">CSS</span>
							<span className="resume_skill">HTML</span>
							<span className="resume_skill">Liquid (Shopify)</span>
							<span className="resume_skill">React</span>
							<span className="resume_skill">Shopify CLI</span>
							<span className="resume_skill">Storefront API</span>
							<span className="resume_skill">Metafields / Metaobjects</span>
							<span className="resume_skill">Next.js</span>
							<span className="resume_skill">Shopify Admin API</span>
							<span className="resume_skill">GraphQL</span>
							<span className="resume_skill">Git</span>
							<span className="resume_skill">Performance Optimization</span>
							<span className="resume_skill">Responsive Design</span>
							<span className="resume_skill">Google Cloud Run</span>
						</div>
					</section>

					<section className="resume_section">
						<h2 className="resume_section_title">Work Experience</h2>

						<div className="resume_job">
							<div className="resume_job_header">
								<div>
									<span className="resume_job_company">Partify, Inc.</span>
									<span className="resume_job_role">Web Developer</span>
								</div>
								<span className="resume_job_dates">Oct 2024 – Present</span>
							</div>
							<ul className="resume_job_bullets">
								<li>
									Design, develop, and implement customer-facing eCommerce
									features using HTML, CSS, JavaScript, and Shopify Liquid
								</li>
								<li>
									Build responsive, cross-browser UI components that improve
									usability across desktop and mobile shopping experiences
								</li>
								<li>
									Use Shopify CLI and modern development workflows to test,
									deploy, and maintain production-ready features
								</li>
								<li>
									Collaborate with team members to ensure new features align
									with project goals and enhance user experience
								</li>
								<li>
									Optimize storefront performance, page load speed, and
									interactive elements to support conversion and SEO goals
								</li>
							</ul>
						</div>

						<div className="resume_job">
							<div className="resume_job_header">
								<div>
									<span className="resume_job_company">
										Shopify App Developer
									</span>
									<span className="resume_job_role">Self-Employed</span>
								</div>
								<span className="resume_job_dates">Dec 2025 – Present</span>
							</div>
							<ul className="resume_job_bullets">
								<li>
									Built and published a Shopify app (BlogConnect: Comment
									Manager) to the Shopify App Store
								</li>
								<li>
									App replaces the basic native blog comments with threaded
									discussions and full comment moderation directly in Shopify
									admin
								</li>
								<li>
									Navigated Shopify's App Store review process, partner
									dashboard, and billing/subscription APIs
								</li>
							</ul>
						</div>

						<div className="resume_job">
							<div className="resume_job_header">
								<div>
									<span className="resume_job_company">
										Freelance Website Developer
									</span>
									<span className="resume_job_role">Self-Employed</span>
								</div>
								<span className="resume_job_dates">Aug 2024 – Nov 2025</span>
							</div>
							<ul className="resume_job_bullets">
								<li>
									Designed and developed a full custom website for a client
									using React and Next.js, currently live at cashewgetsajob.com
								</li>
								<li>
									Integrated Shopify's Admin API to dynamically serve blog
									content and generate customer-specific discount codes based on
									user segmentation
								</li>
								<li>
									Handled end-to-end delivery including client communication,
									deployment, and ongoing maintenance
								</li>
							</ul>
						</div>
					</section>

					<section className="resume_section">
						<h2 className="resume_section_title">Certifications</h2>
						<div className="resume_job">
							<div className="resume_job_header">
								<div>
									<span className="resume_job_company">Alchemy University</span>
									<span className="resume_job_role">
										Ethereum Developer Bootcamp
									</span>
								</div>
								<span className="resume_job_dates">Aug 2023</span>
							</div>
							<ul className="resume_job_bullets">
								<li>
									Completed programming curriculum covering application
									architecture, API design, and secure development practices
								</li>
							</ul>
						</div>
					</section>

					<section className="resume_section">
						<h2 className="resume_section_title">Education</h2>
						<div className="resume_job">
							<div className="resume_job_header">
								<div>
									<span className="resume_job_company">
										Northwest Missouri State University
									</span>
									<span className="resume_job_role">
										Bachelor of Science — Agribusiness, Agronomy &amp; Animal
										Science
									</span>
								</div>
								<span className="resume_job_dates">Class of 2018</span>
							</div>
							<ul className="resume_job_bullets">
								<li>4.0 / 4.0 GPA</li>
							</ul>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
}

export default Resume;
